/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StateKeyWrapper = {
    type: 'string',
    description: `Representation of a StateKey as a hex string. This is used for cursor based pagination.
    `,
} as const;
